<template>
<div>
    <BreadCrumb class="bread" :breads="['商品管理','统一调价',title]"></BreadCrumb>
    <div class="wrap">
        <div class="header">
            <span class="nameFt">{{ title }}</span>
            <div style="margin-right: 20px;">
                <router-link :to="{path:'/index/unifiedPrice'}">
                    <el-button class="addCustom" size="small" icon="el-icon-arrow-left">
                        返回列表
                    </el-button>
                </router-link>
                <el-button type="primary" v-if="seeLook==true" @click="confirm" size="small">确 认</el-button>
            </div>
        </div>
    </div>
    <el-form ref="form" size="small" class="form-container" label-width="120px" :rules="rules" :model="formData">
        <div class="form-container__left">
            <el-form-item label="名称" prop="change_name">
                <el-input v-model="formData.change_name" :disabled="seeLook==false" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="描述" prop="change_remark">
                <el-input v-model="formData.change_remark" :disabled="seeLook==false" maxlength="20" type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="关联商品">
                <el-radio :label="1" v-model="formData.items_range" :disabled="seeLook==false" @change="handleItemsRangeChange">全部商品</el-radio>
                <el-radio :label="2" v-model="formData.items_range" :disabled="seeLook==false" @change="handleItemsRangeChange">指定商品</el-radio>
            </el-form-item>

            <el-button class="table-con__header-button" type="primary" size="small" @click="fetchData" :disabled="seeLook== false" v-if="formData.items_range===2 ">新增</el-button>
            <el-form-item label="应用范围">
                <el-radio :label="1" :disabled="seeLook==false" v-model="formData.terminal_range">全部设备</el-radio>
                <el-radio :label="2" :disabled="seeLook==false" v-model="formData.terminal_range">指定设备</el-radio>
            </el-form-item>

            <el-form-item label="设备编号" v-if="formData.terminal_range===2">
                <el-input size="small" placeholder="请选择设备编号" style="width:200px;height: 40px;z-index: 999;" v-model="search.hard_number" suffix-icon="el-icon-search" :disabled="seeLook==false" readonly @focus="setDialogSearchItem('hard_number')"></el-input>
                <!-- <el-button size="small"  @click="getSpecify" type="primary">指定设备编码</el-button> -->
            </el-form-item>

            <el-form-item label="设备编号列表" v-if="formData.terminal_range== 2">
                <el-table :data="hardData" style="width:1000px;margin-left:100px;margin-top:20px">
                    <el-table-column type="index" :index="indexMethod" label="序号" width="55" align="center"></el-table-column>
                    <el-table-column prop="terminal_number" label="设备名称" width="200" align="center"></el-table-column>
                    <el-table-column prop="hard_number" label="机器编号" width="200" align="center"></el-table-column>
                    <el-table-column prop="point_name" label="点位名称" width="200" align="center"></el-table-column>
                    <el-table-column label="操作" v-if="seeLook==true" width="300" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="getSpecify(scope.row.id)" type="primary">当前设备陈列</el-button>
                            <el-button size="mini" @click="spliceHardData(scope.$index)" type="danger">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>

            <el-form-item label="价格调整">
                <el-radio :label="1" v-model="formData.price_range" :disabled="formData.items_range==1">指定价格(必须是指定商品)</el-radio>
                <el-radio :label="2" v-model="formData.price_range" :disabled="formData.items_range==2">全部上调(全部商品)</el-radio>
                <el-radio :label="3" v-model="formData.price_range" :disabled="formData.items_range==2">全部下调(全部商品)</el-radio>
            </el-form-item>

            <el-form-item label="调整比例" prop="change_ratio" v-if="formData.price_range==2 || formData.price_range == 3">
                <el-input :disabled="seeLook==false" v-model="formData.change_ratio" placeholder="请输入调整比例" maxlength="20" style="width:300px">
                    <template slot="append">%</template>
                </el-input>
            </el-form-item>

        </div>
    </el-form>

    <div style="margin-left: 68%;">
        <!-- 独立的按钮，与表格平齐 -->
        <el-button v-if="formData.price_range==1 " :disabled="seeLook== false" type="primary" size="small" style="vertical-align: middle;" @click="handleStandaloneButton">
            指定价格全部调整
        </el-button>
    </div>
    <el-table :data="priceData" style="width:1200px;margin-left:100px">

        <el-table-column prop="name" label="商品名称" width="200" align="center"></el-table-column>
        <el-table-column prop="spec" label="商品图片" width="200">
            <template slot-scope="scope">
                <span class="img-box">
                    <img :src="scope.row.image_url" alt width="80px" height="80px" align="center" />
                </span>
            </template>
        </el-table-column>
        <el-table-column prop="barcode" label="商品编号" width="200" align="center"></el-table-column>
        <el-table-column prop="real_price" label="价格" width="200" align="center" v-if="seeLook==true"></el-table-column>
        <el-table-column prop="raw_price" label="价格" width="200" align="center" v-if="seeLook==false"></el-table-column>
        <!-- <el-table-column prop="last_price" label="商品编号" width="200" align="center"></el-table-column> -->
        <el-table-column prop="last_price" label="改价" width="200" align="center">
            <template slot-scope="scope">
                <el-input v-model.number="scope.row.last_price" :placeholder="formData.price_range == 1 ? '请输入改价' : ''" :disabled="seeLook==false" @input="handleInputChange(scope.row, $event)"></el-input>
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" v-if="seeLook==true">
            <div slot-scope="scope">
                <el-button size="mini" @click="removeOrderItem(scope.$index)" type="danger">删除</el-button>
            </div>
        </el-table-column>
    </el-table>

    <el-dialog title="商品名称" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
        <el-form :inline="true" :model="searchForm" class="search-form">
            <el-form-item label="商品名称">
                <el-input v-model="searchForm.name" placeholder="请输入商品名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch">查询</el-button>
                <el-button @click="resetSearch">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="id" label="ID" width="100"></el-table-column>
            <el-table-column prop="name" label="商品名称" width="200"></el-table-column>
            <el-table-column prop="spec" label="商品图片">
                <template slot-scope="scope">
                    <span class="img-box">
                        <img :src="scope.row.image_url" alt width="80px" height="80px" />
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="barcode" label="条形码"></el-table-column>
            <el-table-column prop="number" label="编号"></el-table-column>
            <el-table-column prop="real_price" label="价格"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination @current-change="handleSizeChange" :page-size="10" :current-page="itemsPaging.page_index" layout="total, prev, pager, next" :total="total"></el-pagination>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>

    <el-dialog title="商品名称" :visible.sync="buttondialogVisible" width="50%" :before-close="handleClose">
        <el-table :data="buttonTableData" style="width: 100%" @selection-change="handleButtonSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="id" label="ID" width="100"></el-table-column>
            <el-table-column prop="name" label="商品名称" width="200"></el-table-column>
            <el-table-column prop="spec" label="商品图片">
                <template slot-scope="scope">
                    <span class="img-box">
                        <img :src="scope.row.image_url" alt width="80px" height="80px" />
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="barcode" label="条形码"></el-table-column>
            <el-table-column prop="number" label="编号"></el-table-column>
            <el-table-column prop="real_price" label="价格"></el-table-column>
        </el-table>

        <span slot="footer" class="dialog-footer">
            <el-button @click="buttondialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleButtonConfirm">确 定</el-button>
        </span>

    </el-dialog>

    <el-dialog title="独立调整价格" :visible.sync="priceDialogVisible" width="550px" :before-close="handleClose">
        <el-input v-model="formData.change_ratio" placeholder="支持：5（加5元） / -2（减2元） / 10%（加10%）/ -8%（减8%)" maxlength="20" style="width:500px" />
        <span slot="footer" class="dialog-footer">
            <el-button @click="priceDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="priceDialogVisible = false">确 定</el-button>
        </span>
    </el-dialog>

    <!-- <simple-find-dialog :show="sipDialogVisible" @close="closeSimpleDialog" :dialogData="dialogData" :width="'500px'">
    </simple-find-dialog> -->
    <simple-double-dialog :show="sipDialogVisible" @close="closeSimpleDialog" :dialogData="dialogData" :width="'500px'">
    </simple-double-dialog>

</div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import apis from "@/config/apis/index";
import SelectGroupDialog from "@/components/SelectGroupDialog";
import SimpleFindDialog from "@/components/SimpleFindDialog";
import SimpleDoubleDialog from "@/components/SimpleDoubleDialog";
export default {
    data() {
        return {
            formData: {
                terminal_type_name: "",
                terminal_rows: "",
                created_at: "",
                radio1: "新增商品",
                radio2: '1',
                items_range: 1, // 初始化为 null 或默认值（1 或 2）
                terminal_range: 1,
                price_range: 2,
                change_ratio: '',

            },
            rules: {
                change_name: {
                    required: true,
                    message: "请输入名称"
                },
                change_remark: {
                    required: true,
                    message: "请输入描述"
                },
                change_ratio: {
                    required: true,
                    message: '请输入调整比例'
                }
            },
            dialogVisible: false,
            sipDialogVisible: false,
            buttondialogVisible: false,
            priceDialogVisible: false,
            dialogData: {},
            nowDialog: "",
            searchForm: {
                name: "",

            },
            search: {
                hard_number: ""
            },
            tableData: [],
            hardData: [],
            buttonTableData: [],
            selectedRows: [], // 存储选中的行
            buttonSelectedRows: [], // 第二个弹窗选中的行
            currentPage: 1,
            pageSize: 10,
            total: 0,
            itemsPaging: {},
            priceData: [],
            sid: '',
            seeLook: true,
        }

    },

    components: {
        SelectGroupDialog,
        SimpleFindDialog,
        SimpleDoubleDialog
    },
    computed: {
        title() {
            if (!this.$route.query.id) {
                return "新增调价";
            } else {
                return "查看调价";
            }
        },
    },
    created() {
        if (this.$route.query.id) {
            this.seeLook = false;
            this.getData(this.$route.query.id);
        }
    },
    watch: {
        "formData.change_ratio": {
            handler(newVal) {
                // 当调整比例变化时，计算 last_price
                this.calculateLastPrice(newVal);
            },
            immediate: true, // 立即执行一次
        },

        "formData.price_range": {

            handler(newVal) {
                if (!this.$route.query.id) {
                    if (newVal) {
                        this.priceData.forEach((item) => {
                            this.$set(item, "last_price", item.real_price || 0);
                        });
                    }
                }

            },
        }

    },

    methods: {
        getData() {
            this.$axios
                .get(apis.price_change + this.$route.query.id + '/')

                .then(res => {
                    this.formData = res.data.data;
                    this.hardData = res.data.data.terminals;
                    this.priceData = res.data.data.items;
                });
        },
        fetchData() {
            this.dialogVisible = true;
            let params = {
                page_index: this.itemsPaging.page_index,
                page_size: this.pageSize,
                name: this.searchForm.name
            }
            this.$axios.get(apis.product_library, {
                params
            }).then(res => {
                this.tableData = res.data.data;
                this.itemsPaging = res.data.pagination;
                this.total = res.data.pagination.total_count;
            })

        },
        calculateLastPrice(val) {
            if (!val && val !== 0) return;

            const input = String(val).trim();
            if (!input) return;

            const isPercent = input.includes('%');

            this.priceData.forEach((item) => {
                const basePrice = Number(item.real_price) || 0;
                let newPrice = basePrice;

                if (isPercent) {
                    // ===== 百分比模式 =====
                    const percent = parseFloat(input.replace('%', ''));
                    if (isNaN(percent)) return;

                    newPrice = basePrice + (basePrice * percent) / 100;
                } else {
                    // ===== 固定金额模式 =====
                    const changeAmount = parseFloat(input);
                    if (isNaN(changeAmount)) return;

                    newPrice = basePrice + changeAmount;
                }

                // 防止出现负数价格（可选）
                newPrice = newPrice < 0 ? 0 : newPrice;

                this.$set(item, "last_price", newPrice.toFixed(2));
            });
        },

        handleItemsRangeChange(value) {
            console.log(value, 'value')
            if (value == 2) {
                this.formData.price_range = 1;
                //  localStorage.getItem("priceData")
            }
            if (value == 1) {
                this.formData.price_range = 2;
                // localStorage.clear();
                this.priceData = [];
            }
        },

        // 处理输入框变化
        handleInputChange(row, value) {
            console.log(value, 'value')
            if (this.formData.price_range == 1) {
                this.$set(row, "last_price", value);
            }
        },
        handleSearch() {
            this.itemsPaging.page_index = 1; // 重置到第一页
            this.fetchData();
        },
        // 重置搜索
        resetSearch() {
            this.searchForm.name = "";
            this.itemsPaging.page_index = 1;
            this.fetchData();
        },
        // 选择行变化
        handleSelectionChange(val) {
            this.selectedRows = val;
        },
        handleButtonSelectionChange(val) {
            this.buttonSelectedRows = val;
        },
        // 页码变化
        handleSizeChange(val) {
            this.itemsPaging.page_index = val;
            this.fetchData();
        },
        // 确认选择
        handleConfirm() {
            if (this.selectedRows.length === 0) {
                this.$message.warning("请选择商品！");
                return;
            }

            // 过滤出没有重复 id 的新选商品
            const newItems = this.selectedRows.filter((newItem) => {
                return !this.priceData.some((existingItem) => existingItem.id === newItem.id);
            });

            if (newItems.length > 0) {
                // 为新选商品设置默认 last_price 为 real_price
                const updatedItems = newItems.map((item) => ({
                    ...item,
                    last_price: item.real_price, // 默认显示 real_price
                }));
                this.priceData.push(...updatedItems);
                // localStorage.setItem('priceData',this.priceData)
                this.$message.success("选择成功！");
            } else {
                this.$message.warning("所选商品已存在！");
            }

            this.dialogVisible = false;
        },
        setDialogSearchItem(type) {
            switch (type) {
                case "hard_number":
                    this.dialogData = {
                        searchItems: [{
                            key: "hard_number",
                            label: "设备编号"
                        }],
                        searchTableItem: [{
                            key: "terminal_number",
                            name: "设备名称"
                        }, {
                            key: "hard_number",
                            name: "设备编号"
                        }, {
                            key: "point_name",
                            name: "点位名称"
                        }, ],
                        proxyLink: "terminal_list",
                        proxyType: "get"
                    };
                    break;
            }
            this.sipDialogVisible = true;
            this.nowDialog = type;
        },

        closeSimpleDialog(data) {
            // console.log(data,'data.terminal_number')
            const _data = [];
            for (let i = 0; i < data.length; i++) {
                _data.push({
                    terminal_number: data[i].terminal_number,
                    hard_number: data[i].hard_number,
                    point_name: data[i].point_name,
                    id: data[i].id,
                })
            }
            this.sipDialogVisible = false;
            switch (this.nowDialog) {
                case "hard_number":
                    // 确保 this.hardData 是一个数组
                    if (!Array.isArray(this.hardData)) {
                        this.hardData = [];
                    }
                    // 过滤掉重复项并追加到 this.hardData
                    _data.forEach(item => {
                        // 检查 this.hardData 中是否已存在相同 id 的项
                        const exists = this.hardData.some(existingItem => existingItem.id === item.id);
                        if (!exists) {
                            this.hardData.push(item);
                        } else {
                            this.$message.error('已存在设备编号，请勿重复添加')
                        }
                    });
                    // 调试输出
                    console.log('追加后的 this.hardData:', this.hardData);
                    break;
                default:
                    console.warn(`未知的 dialog 类型: ${this.nowDialog}`);
                    break;
            }

        },

        getSpecify(id) {
            this.$axios
                .get(apis.items_terminal_info + id + '/')
                .then(res => {
                    this.buttondialogVisible = true;
                    this.buttonTableData = res.data.data;

                });
        },
        // 第二个弹窗确认选择
        handleButtonConfirm() {
            if (this.buttonSelectedRows.length === 0) {
                this.$message.warning("请选择商品！");
                return;
            }

            // 过滤出没有重复 id 的新选商品
            const newItems = this.buttonSelectedRows.filter((newItem) => {
                return !this.priceData.some((existingItem) => existingItem.id === newItem.id);
            });

            if (newItems.length > 0) {
                // 为新选商品设置默认 last_price 为 real_price
                const updatedItems = newItems.map((item) => ({
                    ...item,
                    last_price: item.real_price, // 默认显示 real_price
                }));
                this.priceData.push(...updatedItems);
                this.$message.success("选择成功！");
            } else {
                this.$message.warning("所选商品已存在！");
            }
            this.buttondialogVisible = false;

            // const newItems = this.buttonSelectedRows.filter((newItem) => {
            //     return !this.priceData.some((existingItem) => existingItem.id === newItem.id);
            // });

            // if (newItems.length > 0) {
            //     this.priceData.push(...newItems);
            //     this.$message.success("选择成功！");
            // } else {
            //     this.$message.warning("所选商品已存在！");
            // }

        },
        handleStandaloneButton() {
            this.priceDialogVisible = true;
        },

        //删除商品
        removeOrderItem(index) {
            this.priceData.splice(index, 1);
        },
        spliceHardData(index) {
            this.hardData.splice(index, 1);
        },
        confirm() {
            console.log('123456', '123456')
            this.$refs["form"].validate((valid) => {
                if (valid) {

                    console.log(this.priceData, 'this.priceData[i].id')
                    let _terminals = [];
                    if (this.hardData.length > 0) {
                        for (let i = 0; i < this.hardData.length; i++) {
                            _terminals.push({
                                hard_number: this.hardData[i].hard_number
                            });
                        }
                    }
                    let _priceData = [];
                    if (this.priceData.length > 0) {
                        for (let i = 0; i < this.priceData.length; i++) {
                            _priceData.push({
                                items_id: this.priceData[i].id,
                                raw_price: this.priceData[i].real_price,
                                last_price: this.priceData[i].last_price
                            });
                        }
                        console.log(_priceData, '_priceData_priceData')
                    }
                    let jsonData = {
                        terminal_range: this.formData.terminal_range,
                        change_remark: this.formData.change_remark,
                        items_range: this.formData.items_range,
                        price_range: this.formData.price_range,
                        change_ratio: this.formData.change_ratio,
                        change_name: this.formData.change_name,
                        terminals: _terminals,
                        items: _priceData
                    }
                    this.$axios.post(apis.price_change, jsonData).then((res) => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: "success",
                                message: "新增成功",
                            });
                            this.goback();
                        } else {
                            this.$message({
                                type: "error",
                                message: res.data.msg,
                            });
                        }
                    });
                }
            })
        },
        goback() {
            this.$router.push({
                name: 'unifiedPrice'
            })
        },
        // handleButtonConfirm() {
        //     this.buttondialogVisible = false;
        //     this.priceData = this.buttonTableData;
        // },

    },

}
</script>
